import actionTypes from './actionTypes';

const INIT_STATE = {
  createRseeDiscountRequestLoading: false,
  createRseeDiscountRequestFailed: false,
  createRseeDiscountRequestError: false,
  createRseeDiscountRequestMessage: '',

  getMyRseeDiscountsListLoading: false,
  getMyRseeDiscountsListFailed: false,
  getMyRseeDiscountsListError: false,
  getMyRseeDiscountsListMessage: null,

  rseeDiscountRequestsLoading: false,
  rseeDiscountRequestsFailed: false,
  rseeDiscountRequestsError: false,
  rseeDiscountRequestsMessage: null,
  rseeDiscountRequestsList: [],
  rseeDiscountRequests: {},


  rseeDiscountRequestArchivesLoading: false,
  rseeDiscountRequestArchivesFailed: false,
  rseeDiscountRequestArchivesError: false,
  rseeDiscountRequestArchivesMessage: null,
  rseeDiscountRequestArchivesList: [],
  rseeDiscountRequestArchives: {},


  rseeDiscountRequestDetailsByIdLoading: false,
  rseeDiscountRequestDetailsByIdFailed: false,
  rseeDiscountRequestDetailsByIdError: false,
  rseeDiscountRequestDetailsByIdMessage: null,
  rseeDiscountRequestDetailsById: {},


  updateRseeDiscountRequestStatusLoading: false,
  updateRseeDiscountRequestStatusFailed: false,
  updateRseeDiscountRequestStatusError: false,
  updateRseeDiscountRequestStatusMessage: null,



  activateRseeDiscountLoading: false,
  activateRseeDiscountFailed: false,
  activateRseeDiscountError: false,
  activateRseeDiscountMessage: null,


  myRseeDiscountsList: [],
  myRseeDiscountsListTotalRecords: 0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_LOADING: {
      return {
        ...state,
        createRseeDiscountRequestLoading: true,
        createRseeDiscountRequestFailed: false,
        createRseeDiscountRequestError: false,
        createRseeDiscountRequestMessage: ''
      };
    }
    case actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_SUCCESS: {
      return {
        ...state,
        createRseeDiscountRequestLoading: false,
        createRseeDiscountRequestFailed: false,
        createRseeDiscountRequestError: false,
        createRseeDiscountRequestMessage: ''
      };
    }
    case actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_REJECT: {
      return {
        ...state,
        createRseeDiscountRequestLoading: false,
        createRseeDiscountRequestFailed: false,
        createRseeDiscountRequestError: true,
        createRseeDiscountRequestMessage: ''
      };
    }
    case actionTypes.CREATE_RSEE_DISCOUNT_REQUEST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        createRseeDiscountRequestLoading: false,
        createRseeDiscountRequestFailed: true,
        createRseeDiscountRequestError: false,
        createRseeDiscountRequestMessage: message
      };
    }

    case actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_LOADING:
      return {
        ...state,
        myRseeDiscountsList: [],
        myRseeDiscountsListTotalRecords: 0,
        getMyRseeDiscountsListLoading: true,
        getMyRseeDiscountsListFailed: false,
        getMyRseeDiscountsListError: false,
        getMyRseeDiscountsListMessage: null
      };
    case actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        myRseeDiscountsList: action.payload.rseeDiscounts,
        myRseeDiscountsListTotalRecords: action.payload.totalRecords,
        getMyRseeDiscountsListLoading: false,
        getMyRseeDiscountsListFailed: false,
        getMyRseeDiscountsListError: false,
        getMyRseeDiscountsListMessage: null
      };
    case actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_FAILED:
      return {
        ...state,
        myRseeDiscountsList: [],
        myRseeDiscountsListTotalRecords: 0,
        getMyRseeDiscountsListLoading: false,
        getMyRseeDiscountsListFailed: false,
        getMyRseeDiscountsListError: false,
        getMyRseeDiscountsListMessage: action.payload.message
      };
    case actionTypes.GET_MY_RSEE_DISCOUNTS_LIST_REJECT:
      return {
        ...state,
        myRseeDiscountsList: [],
        myRseeDiscountsListTotalRecords: 0,
        getMyRseeDiscountsListLoading: false,
        getMyRseeDiscountsListFailed: false,
        getMyRseeDiscountsListError: true,
        getMyRseeDiscountsListMessage: null
      };


    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_LOADING:
      return {
        ...state,
        rseeDiscountRequests: {},
        rseeDiscountRequestsList: [],
        rseeDiscountRequestsLoading: true,
        rseeDiscountRequestsFailed: false,
        rseeDiscountRequestsError: false,
        rseeDiscountRequestsMessage: null
      };
    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_SUCCESS:
      return {
        ...state,
        rseeDiscountRequests: { ...action.payload },
        rseeDiscountRequestsList: [...action.payload.rseeDiscounts],
        rseeDiscountRequestsLoading: false,
        rseeDiscountRequestsFailed: false,
        rseeDiscountRequestsError: false,
        rseeDiscountRequestsMessage: null
      };
    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_FAILED:
      return {
        ...state,
        rseeDiscountRequests: {},
        rseeDiscountRequestsList: [],
        rseeDiscountRequestsLoading: false,
        rseeDiscountRequestsFailed: false,
        rseeDiscountRequestsError: false,
        rseeDiscountRequestsMessage: action.payload.message
      };
    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUESTS_REJECT:
      return {
        ...state,
        rseeDiscountRequests: {},
        rseeDiscountRequestsList: [],
        rseeDiscountRequestsLoading: false,
        rseeDiscountRequestsFailed: false,
        rseeDiscountRequestsError: true,
        rseeDiscountRequestsMessage: null
      };



    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_LOADING:
      return {
        ...state,
        rseeDiscountRequestArchives: {},
        rseeDiscountRequestArchivesList: [],
        rseeDiscountRequestArchivesLoading: true,
        rseeDiscountRequestArchivesFailed: false,
        rseeDiscountRequestArchivesError: false,
        rseeDiscountRequestArchivesMessage: null
      };
    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS:
      return {
        ...state,
        rseeDiscountRequestArchives: { ...action.payload },
        rseeDiscountRequestArchivesList: [...action.payload.rseeDiscounts],
        rseeDiscountRequestArchivesLoading: false,
        rseeDiscountRequestArchivesFailed: false,
        rseeDiscountRequestArchivesError: false,
        rseeDiscountRequestArchivesMessage: null
      };
    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_FAILED:
      return {
        ...state,
        rseeDiscountRequestArchives: {},
        rseeDiscountRequestArchivesList: [],
        rseeDiscountRequestArchivesLoading: false,
        rseeDiscountRequestArchivesFailed: false,
        rseeDiscountRequestArchivesError: false,
        rseeDiscountRequestArchivesMessage: action.payload.message
      };
    case actionTypes.FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_REJECT:
      return {
        ...state,
        rseeDiscountRequestArchives: {},
        rseeDiscountRequestArchivesList: [],
        rseeDiscountRequestArchivesLoading: false,
        rseeDiscountRequestArchivesFailed: false,
        rseeDiscountRequestArchivesError: true,
        rseeDiscountRequestArchivesMessage: null
      };

    case actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_LOADING:
      return {
        ...state,
        rseeDiscountRequestDetailsById: {},
        rseeDiscountRequestDetailsByIdLoading: true,
        rseeDiscountRequestDetailsByIdFailed: false,
        rseeDiscountRequestDetailsByIdError: false,
        rseeDiscountRequestDetailsByIdMessage: null
      };
    case actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        rseeDiscountRequestDetailsById: { ...action.payload },
        rseeDiscountRequestDetailsByIdLoading: false,
        rseeDiscountRequestDetailsByIdFailed: false,
        rseeDiscountRequestDetailsByIdError: false,
        rseeDiscountRequestDetailsByIdMessage: null
      };
    case actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_FAILED:
      return {
        ...state,
        rseeDiscountRequestDetailsById: {},
        rseeDiscountRequestDetailsByIdLoading: false,
        rseeDiscountRequestDetailsByIdFailed: false,
        rseeDiscountRequestDetailsByIdError: false,
        rseeDiscountRequestDetailsByIdMessage: action.payload.message
      };
    case actionTypes.FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_REJECT:
      return {
        ...state,
        rseeDiscountRequestDetailsById: {},
        rseeDiscountRequestDetailsByIdLoading: false,
        rseeDiscountRequestDetailsByIdFailed: false,
        rseeDiscountRequestDetailsByIdError: true,
        rseeDiscountRequestDetailsByIdMessage: null
      };


    case actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_LOADING:
      return {
        ...state,
        updateRseeDiscountRequestStatusLoading: true,
        updateRseeDiscountRequestStatusFailed: false,
        updateRseeDiscountRequestStatusError: false,
        updateRseeDiscountRequestStatusMessage: null
      };
    case actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_SUCCESS:
      return {
        ...state,
        updateRseeDiscountRequestStatusLoading: false,
        updateRseeDiscountRequestStatusFailed: false,
        updateRseeDiscountRequestStatusError: false,
        updateRseeDiscountRequestStatusMessage: null
      };
    case actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_FAILED:
      return {
        ...state,
        updateRseeDiscountRequestStatusLoading: false,
        updateRseeDiscountRequestStatusFailed: false,
        updateRseeDiscountRequestStatusError: false,
        updateRseeDiscountRequestStatusMessage: action.payload.message
      };
    case actionTypes.UPDATE_RSEE_DISCOUNT_REQUEST_REJECT:
      return {
        ...state,
        updateRseeDiscountRequestStatusLoading: false,
        updateRseeDiscountRequestStatusFailed: false,
        updateRseeDiscountRequestStatusError: true,
        updateRseeDiscountRequestStatusMessage: null
      };



    case actionTypes.ACTIVATE_RSEE_DISCOUNT_LOADING:
      return {
        ...state,
        activateRseeDiscountLoading: true,
        activateRseeDiscountFailed: false,
        activateRseeDiscountError: false,
        activateRseeDiscountMessage: null
      };
    case actionTypes.ACTIVATE_RSEE_DISCOUNT_SUCCESS:
      return {
        ...state,
        activateRseeDiscountLoading: false,
        activateRseeDiscountFailed: false,
        activateRseeDiscountError: false,
        activateRseeDiscountMessage: null
      };
    case actionTypes.ACTIVATE_RSEE_DISCOUNT_FAILED:
      return {
        ...state,
        activateRseeDiscountLoading: false,
        activateRseeDiscountFailed: false,
        activateRseeDiscountError: false,
        activateRseeDiscountMessage: action.payload.message
      };
    case actionTypes.ACTIVATE_RSEE_DISCOUNT_REJECT:
      return {
        ...state,
        activateRseeDiscountLoading: false,
        activateRseeDiscountFailed: false,
        activateRseeDiscountError: true,
        activateRseeDiscountMessage: null
      };

    case actionTypes.CLEAR_CREATE_RSEE_DISCOUNT_REQUEST_FORM: {
      return {
        ...state,
        createRseeDiscountRequestLoading: false,
        createRseeDiscountRequestFailed: false,
        createRseeDiscountRequestError: false,
        createRseeDiscountRequestMessage: ''
      };
    }

    default: {
      return { ...state };
    }
  }
};
